
@if (uploadError()) {
    <div class="alert alert-danger text-center mt-3">
        {{ uploadError() }}
    </div>
}

@if (!allDone()) {
    <h3 class="text-center">
        {{ heading() }}
    </h3>

    <div class="upload-box">
        <div class="submit submit-box-for-show position-relative m-auto" style="width: 300px;">
            <div class="pdf-img">
                <img alt="Document Image" class="fbi-img" width="100%" [src]="featuredImage() || '/assets/img/documents/iso.png'" style="margin: 0 !important;">
            </div>
            <div class="submit-box position-relative">
                <div class="submit-div">
                    <div class="submit-div position-relative">
                        @for (i of indices(); track i) {
                            <input #fileInput class="upload-input" type="file" accept="application/pdf"
                                [style.display]="i === currentIndex() ? 'block' : 'none'"
                                (change)="onFileSelected($event, i)">
                        }
                        <span class="upload-text" style="font-size: 20px;">
                            Please
                            <img src="/assets/imgs/click-here1.gif" style="margin: 0 !important; width: 100px; display: inline-block !important;">
                            Upload Your Digital File
                        </span>
                    </div>
                    <div class="upload-div">
                        <div class="upload-content">
                            <i class="fa-solid fa-upload"></i> <br>
                            Upload
                            your <br> <span class="text-danger">digital</span> file.
                        </div>
                        <div class="total inputs-container-step1" style="display: none;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
} @else {
    <h3 class="text-center text-success">
        <i class="fa-solid fa-circle-check"></i> All documents uploaded!
    </h3>
}

<!-- Preview Modal -->
<div class="modal fade" [class.show]="showPreviewModal()"
    [style.display]="showPreviewModal() ? 'block' : 'none'" tabindex="-1" aria-labelledby="previewModalLabel"
    aria-hidden="true" role="dialog">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="previewModalLabel">Preview Your Document</h5>
                <button type="button" class="btn-close" (click)="onCancelFile()" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                @if (previewUrl()) {
                    <iframe [src]="previewUrl()!" width="100%" height="500px" style="border: none;"></iframe>
                }
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="onCancelFile()">Cancel</button>
                <button type="button" class="btn btn-success" (click)="onAcceptFile()">Accept</button>
            </div>
        </div>
    </div>
</div>

<!-- Extra Pages Modal -->
<div class="modal fade" [class.show]="showExtraPagesModal()"
    [style.display]="showExtraPagesModal() ? 'block' : 'none'" tabindex="-1" aria-labelledby="extraPagesModalLabel"
    aria-hidden="true" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="extraPagesModalLabel">Additional Pages Fee</h5>
                <button type="button" class="btn-close" (click)="onCancelFile()" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p>Your document has <strong>{{ pendingPageCount() }}</strong> pages.</p>
                <p>Pages beyond 10 will incur an additional fee of <strong>$0.25 per page</strong>.</p>
                <p>Total additional fee for this document: <strong>${{ ((pendingPageCount() - 10) * 0.25).toFixed(2) }}</strong></p>
                <p>Do you want to accept this charge or proceed with a physical hard copy?</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="onHardCopyFromUpload()">Proceed with Hard Copy</button>
                <button type="button" class="btn btn-success" (click)="onAcceptExtraPages()">Accept Charge</button>
            </div>
        </div>
    </div>
</div>

@if (showPreviewModal() || showExtraPagesModal()) {
    <div class="modal-backdrop fade show"></div>
}